var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 577,
    viewBox: "0 0 364 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter0_f_733_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217 285.5L201 201H399.5V238.5V285.5V354.5L373.5 376L285.5 354.5L278 309L259.5 285.5H217Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 285.5L201 201H399.5V238.5V285.5V354.5L373.5 376L285.5 354.5L278 309L259.5 285.5H217Z",
    fill: "#3B88CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 285.5L201 201H399.5V238.5V285.5V354.5L373.5 376L285.5 354.5L278 309L259.5 285.5H217Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_733_84",
    x: 0.396423,
    y: 0.5,
    width: 599.604,
    height: 576.045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_733_84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBlur);
export default __webpack_public_path__ + "static/media/TopBlur.bbe0e9663fd8d728febf1800db954b3b.svg";
export { ForwardRef as ReactComponent };